import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

interface Option {
  label: string;
  value: string;
}


interface Question {
  answer?: any;
  dependentOn?: string | null;
  dependentValue?: string | null;
  headerText?: string | null;
  inputType: 'radio' | 'text' | 'dropdown' | 'slider' | 'multiselect';
  isActive: boolean;
  max?: number | null;
  min?: number | null;
  options?: Option[] | null;
  optionsList?: Option[] | null;
  questionId: any;
  questionNumber: number;
  questionText: string;
  isRequired: boolean;
  minLength: number;
  maxLength: number;
  pattern: string;
}

interface Section {
  sectionTitle: string;
  questions: Question[];
}

interface FormValues {
  [key: string]: { [subKey: string]: string };
}

interface UserQuestions {
  //UserId: any;
  //UserType:number;
  iaQuestionAnswerMapping: any[];
}

@Component({
  selector: 'app-iaquestionanswer',
  templateUrl: './iaquestionanswer.component.html',
  styleUrl: './iaquestionanswer.component.css'
})
export class IaquestionanswerComponent {
 form!: FormGroup;
  responseData: Section[] = [];
  currentSectionIndex = 0;
  iaQuestionAnswerMapping: any[] = [];
  selectedObjects: any[] = [];
  selectedObjectsFromArray: any;
  isVisible: boolean = true;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {    
    const obj = { UserId: sessionStorage.getItem('userId'),   UserType:2 };
    this.createForm();
  }

  onSliderChange(event: Event, sectionTitle: string, questionId: number): void {
    //debugger; // This will pause execution at this line when the slider is changed
    const value = (event.target as HTMLInputElement).value;
    //console.log(`Slider value changed: ${value}`);
    this.form.get(sectionTitle)?.get('question_' + questionId)?.setValue(Number(value));
  }
  convertToWords(num: number): string {
    if (num === 0) return 'zero';

    const ones = [
      '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
      'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
      'seventeen', 'eighteen', 'nineteen'
    ];
    const tens = [
      '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
    ];

    const convert = (n: number): string => {
      if (n < 20) {
        return ones[n];
      } else if (n < 100) {
        return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
      } else if (n < 1000) {
        return ones[Math.floor(n / 100)] + ' hundred' + (n % 100 !== 0 ? ' and ' + convert(n % 100) : '');
      } else if (n < 1000000) {
        return convert(Math.floor(n / 1000)) + ' thousand' + (n % 1000 !== 0 ? ' ' + convert(n % 1000) : '');
      }
      return 'Number too large';
    };

    return convert(num);
  }

  //createForm(obj: any) {
  //  this.form = this.fb.group({});
  //  this.apiService.getRequest(API_ENDPOINTS.MSME.GETOTHERDETAILS, obj).subscribe(
  //    (response: Section[]) => {
  //      this.responseData = response;


  //      this.responseData.forEach((section) => {
  //        const sectionGroup = this.fb.group({});

  //        section.questions.forEach((question) => {
  //          if (question.isActive && question.questionId) {
  //            const control = new FormControl(
  //              question.answer || '',
  //              this.getValidators(question)
  //            );
  //            sectionGroup.addControl(`question_${question.questionId}`, control);

  //            if (question.dependentOn) {
  //              this.setDependency(sectionGroup, question);
  //            }

  //            if (question.inputType === 'multiselect') {
  //              const multiselectAnswers = section.questions
  //                .filter(q => q.inputType === 'multiselect')
  //                .flatMap(q => JSON.parse(q.answer || '[]'));

  //              this.selectedObjects = multiselectAnswers;

  //            }
  //          }
  //        });

  //        this.form.addControl(section.sectionTitle, sectionGroup);
  //      });
  //    },
  //    (error) => {
  //      this.toastrService.error('Error fetching details', 'Oops...');
  //    }
  //  );
  //}
  createForm() {
    this.form = this.fb.group({});
    this.apiService.getRequest(API_ENDPOINTS.IA.GETOTHERDETAILSIA).subscribe(
      (response: Section[]) => {
        this.responseData = response;
        if (this.responseData.length === 1) {
          this.isVisible = false;
        } else {
          this.isVisible = true;
        }

        this.responseData.forEach((section) => {
          const sectionGroup = this.fb.group({});          

          section.questions.forEach((question) => {
            
            if (question.isActive && question.questionId) {
              const control = new FormControl(
                question.answer || '',
                this.getValidators(question)
              );
              sectionGroup.addControl(`question_${question.questionId}`, control);

              if (question.dependentOn) {
                this.setDependency(sectionGroup, question);
              }

              if (question.inputType === 'multiselect') {
                const multiselectAnswers = section.questions
                  .filter(q => q.inputType === 'multiselect')
                  .flatMap(q => JSON.parse(q.answer || '[]'));
                this.selectedObjects = multiselectAnswers;
              }
            }
          });
          this.form.addControl(section.sectionTitle, sectionGroup);
        });
      },
      (error) => {
        this.toastrService.error('Error fetching details', 'Oops...');
      }
    );
  }

  getValidators(question: Question) {
    const validators = [];
    if (question.isRequired) validators.push(Validators.required);
    if (question.minLength) validators.push(Validators.minLength(question.minLength));
    if (question.maxLength) validators.push(Validators.maxLength(question.maxLength));
    if (question.pattern) validators.push(Validators.pattern(question.pattern));
    return validators;
  }

  setDependency(sectionGroup: FormGroup, question: Question) {
    //debugger;
    const parentControl = sectionGroup.get(`question_${question.dependentOn}`);
    const dependentControl = sectionGroup.get(`question_${question.questionId}`);
  
    // Disable initially, will be enabled based on value changes
    dependentControl?.disable();
    question.isActive = false;
  
    // Enable if the dependent field already has data
    if (question.answer !== null && question.answer !== '') {
      dependentControl?.enable();
      question.isActive = true;
    }
  
    // Subscribe to parent control's value changes
    parentControl?.valueChanges.subscribe((value) => {
      if (value === question.dependentValue) {
        dependentControl?.enable();
        question.isActive = true;
      } else {
        dependentControl?.disable();
        dependentControl?.reset();
        question.isActive = false;
      }
    });
  }


  nextSection() {
    //debugger;
    const currentSection = this.form.get(this.responseData[this.currentSectionIndex].sectionTitle);
    if (currentSection?.valid) {
      this.currentSectionIndex++;
    } else {
      currentSection?.markAllAsTouched();
      this.toastrService.error('Please complete all required fields before proceeding.');
    }
  }

  previousSection() {
    this.currentSectionIndex--;
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }


  

  onSubmit() {
    
    const allValues: FormValues = this.form.getRawValue(); // Get all form values  
    // Map through form values and convert all answers to strings
    this.iaQuestionAnswerMapping = Object.entries(allValues).flatMap(
      ([sectionKey, section]) =>
        Object.entries(section)
          .map(([key, value]) => {
            if (key.startsWith('question_')) {
              const questionNumber = key.split('_')[1];
  
              // Convert all values (numbers, arrays, etc.) to string
              const formattedValue = Array.isArray(value)
                ? JSON.stringify(value) // Convert array to JSON string
                : value?.toString() || ''; // Convert other types to string or empty string
  
              return { questionId: Number(questionNumber), answer: formattedValue };
            }
            return null;
          })
          .filter((item) => item !== null) // Filter out any null values
    );
  



    const resultList: UserQuestions = {
      //UserId: sessionStorage.getItem('userId') ,
      //UserType:2,
      iaQuestionAnswerMapping: this.iaQuestionAnswerMapping,
    };
  
  
  
    // Remove unnecessary properties if present
    if ('isNewEntry' in resultList) {
      delete resultList.isNewEntry;
    }
  

    // Send the data to the backend
    this.apiService.postRequest(API_ENDPOINTS.IA.SAVEIAQUESTIONANSWER, resultList).subscribe(
      (response: any) => {
        if (response.status) {
          this.toastrService.success(response.message, 'Record Saved!');
        } else {
          this.toastrService.error('An unexpected error occurred', 'Oops...');
        }
      },
      (error: any) => {
        this.toastrService.error(error.error.message, 'Oops...');
      }
    );
    //this.apiService.postRequest(API_ENDPOINTS.IA.SAVEIAQUESTIONANSWER, resultList).subscribe(
    //  (response: any) => {
    //    if (response.status) {
    //      this.toastrService.success(response.message, 'Record Saved!');
    //   } else {
    //      this.toastrService.error('An unexpected error occurred', 'Oops...');
    //    }
    //  },
    //  (error: any) => {
    //    this.toastrService.error(error.error.message, 'Oops...');
    //  }
    //);
  }

  

  hasError(sectionTitle: string, questionId: string, errorType: string) {
    const control = this.form.get(sectionTitle)?.get(`question_${questionId}`);
    return control?.hasError(errorType) && control.touched;
  }

  comparer(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.label === o2.label : o2 === o2;
  }
}
